var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aAvatarSVG",
    d: "M26.291 25.492A13.963 13.963 0 0 1 16 30c-4.07 0-7.733-1.736-10.291-4.508l-.192-.039.028-.141A13.948 13.948 0 0 1 2 16C2 8.268 8.268 2 16 2s14 6.268 14 14c0 3.575-1.34 6.837-3.545 9.312l.028.141-.192.039zm-18.851-.73A12.21 12.21 0 0 0 16 28.25a12.21 12.21 0 0 0 8.56-3.487v-.002a1.75 1.75 0 0 0-.829-1.165l-5.38-3.165a1.75 1.75 0 0 1-.265-2.825l.838-.733a4.25 4.25 0 0 0 1.451-3.198V11.06a3.874 3.874 0 0 0-2.141-3.465 4.995 4.995 0 0 0-4.468 0 3.874 3.874 0 0 0-2.141 3.465v2.615a4.25 4.25 0 0 0 1.451 3.198l.838.733a1.75 1.75 0 0 1-.265 2.825l-5.38 3.165a1.75 1.75 0 0 0-.829 1.165v.002zm-1.28-1.465a3.5 3.5 0 0 1 1.222-1.21l5.38-3.164-.838-.733a6 6 0 0 1-2.049-4.515V11.06a5.624 5.624 0 0 1 3.109-5.03 6.745 6.745 0 0 1 6.032 0 5.624 5.624 0 0 1 3.109 5.03v2.615a6 6 0 0 1-2.049 4.515l-.838.733 5.38 3.165a3.5 3.5 0 0 1 1.223 1.209A12.195 12.195 0 0 0 28.25 16c0-6.765-5.485-12.25-12.25-12.25S3.75 9.235 3.75 16c0 2.734.895 5.258 2.41 7.297z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bAvatarSVG",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aAvatarSVG"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    opacity: 0.5,
    fillRule: "nonzero",
    xlinkHref: "#aAvatarSVG"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bAvatarSVG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d117131c.svg";
export { ForwardRef as ReactComponent };